import Reveal from "@/components/Reveal";
import GoldSeam from "@/components/GoldSeam";

export default function Idea() {
  return (
    <section id="idea" className="relative py-24 md:py-36 bg-paper" data-testid="idea-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <Reveal delay={0.1} className="relative order-2 lg:order-1">
          <div className="relative border border-[rgba(169,129,47,0.26)] p-3 md:p-4" data-testid="idea-image-frame">
            <span className="absolute -top-px -left-px w-5 h-5 border-t border-l border-gold" aria-hidden="true" />
            <span className="absolute -bottom-px -right-px w-5 h-5 border-b border-r border-gold" aria-hidden="true" />
            <div className="overflow-hidden">
              <img
                src="/images/bowl-hands.webp"
                alt="Hands holding a ceramic plate repaired with veins of gold — the practice of kintsugi"
                loading="lazy"
                className="w-full h-[320px] md:h-[460px] object-cover hover:scale-[1.03] transition-transform duration-[1400ms] ease-out"
                data-testid="idea-image"
              />
            </div>
          </div>
          <p className="mt-4 text-[10px] uppercase tracking-[0.28em] text-inkdim">
            The repair, highlighted in gold
          </p>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="eyebrow mb-6">The Idea</p>
            <h2 className="font-display text-ink font-medium leading-[1.1] text-4xl sm:text-5xl" data-testid="idea-heading">
              The crack you kept repeating was never the flaw.
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="mt-8 space-y-5 text-inkdim leading-relaxed text-[15px] md:text-base max-w-lg">
              <p>
                In Japan, when a treasured bowl breaks, it isn't thrown away or glued back
                invisibly. It's mended with lacquer dusted in gold — <span className="text-gold">kintsugi</span> —
                so the repair becomes the most valuable part of the object.
              </p>
              <p>
                The same is true of the subconscious patterns high-achieving people carry.
                The loop you keep finding yourself in — the same argument, the same ceiling,
                the same quiet exhaustion — isn't proof that something is wrong with you.
              </p>
              <p className="text-ink font-medium">
                It's the seam. And the seam is where the gold goes.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <GoldSeam variant="horizontal" className="mt-10 w-56 h-10 opacity-70" delay={0.3} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
